import React, { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';
import { Button, Modal } from 'antd';

const UnsavedChangesGuard = ({ hasChanges, isSaving }) => {
	const shouldBlock = hasChanges || isSaving;
	// Every navigation: a page's Standard Builder keeps the path and swaps in through state.
	const blocker = useBlocker(shouldBlock);
	const isBlocked = blocker.state === 'blocked';

	useEffect(() => {
		if (!shouldBlock) return;
		const warnBeforeUnload = e => {
			e.preventDefault();
			e.returnValue = '';
		};
		window.addEventListener('beforeunload', warnBeforeUnload);
		return () => window.removeEventListener('beforeunload', warnBeforeUnload);
	}, [shouldBlock]);

	// A save that lands while the admin is waiting to leave has nothing left to lose.
	useEffect(() => {
		if (isBlocked && !shouldBlock) blocker.proceed();
	}, [isBlocked, shouldBlock]);

	if (!isBlocked || !shouldBlock) return null;

	const stay = () => blocker.reset();

	return isSaving ? (
		<Modal
			open
			title="Saving your changes"
			onCancel={stay}
			footer={<Button onClick={stay}>Stay on this page</Button>}
		>
			You'll leave this page as soon as the save finishes.
		</Modal>
	) : (
		<Modal
			open
			title="You have unsaved changes"
			onCancel={stay}
			footer={[
				<Button key="leave" danger onClick={() => blocker.proceed()}>
					Leave without saving
				</Button>,
				<Button key="stay" type="primary" onClick={stay}>
					Keep editing
				</Button>,
			]}
		>
			If you leave now, your changes to this page will be lost.
		</Modal>
	);
};

export default UnsavedChangesGuard;
